import * as BasketUpdated from '@ori-events/basket-updated';
import * as OpenShadePicker from '@ori-events/open-shade-picker';
import { useInitialDisclose } from '@ori/presentation-hooks';
import { useCallback, useEffect, useState } from 'react';
import { getProductUrl } from '../utils';
export const useShadePickerEvent = () => {
  const [shadePickerData, setShadePickerData] = useState(null);
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = useInitialDisclose();
  const onOpenShadePicker = useCallback(({
    detail: {
      productName,
      products,
      placement,
      goToUrl,
      productCode,
      mode
    }
  }) => {
    setShadePickerData({
      mode,
      productName,
      products,
      placement,
      productCode,
      goToUrl: goToUrl ?? getProductUrl(productCode)
    });
    onOpen();
  }, [onOpen]);
  const onCloseShadePicker = useCallback(() => {
    setShadePickerData(null);
    onClose();
  }, [onClose]);
  useEffect(() => {
    window.addEventListener(OpenShadePicker.Name, onOpenShadePicker);
    window.addEventListener(BasketUpdated.Name, onCloseShadePicker);
    return () => {
      window.removeEventListener(OpenShadePicker.Name, onOpenShadePicker);
      window.removeEventListener(BasketUpdated.Name, onCloseShadePicker);
    };
  }, [onCloseShadePicker, onOpenShadePicker]);
  return {
    data: shadePickerData,
    initialOpenDone,
    onClose,
    open
  };
};
//# sourceMappingURL=useShadePickerEvent.js.map